module.exports = __webpack_public_path__ + "static/media/interview.3c3e6e06.md";